// export const tableHeaders = [
//   { label: 'ID', value: 'gameSubCategoryId' },
//   // { label: 'Casino Game Id', value: 'casinoGameId' },
//   { label: 'Name', value: 'name' },
//   { label: 'Game Category', value: 'categoryname' },
//   { label: 'Thumbnail', value: 'thumbnail' },  
//   // { label: 'System', value: 'system' },
//   // { label: 'Country Restriction Id', value: 'idCountryRestriction' },
//   // { label: 'Status', value: 'status' },
//   { label: 'Actions', value: 'Actions' }

// ]


export const tableHeaders = [
  {
    accessorKey: 'casinoGameId',
    Header: 'casinoGameId',
    value: 'casinoGameId',
    label: 'ID',
  },
  {
    accessorKey: 'name',
    Header: 'name',
    value: 'name',
    label: 'Name',
  },
  {
    accessorKey: 'categoryname',
    Header: 'categoryname',
    value: 'categoryname',
    label: 'Game Category',
  },
  {
    accessorKey: 'thumbnail',
    Header: 'thumbnail',
    value: 'thumbnail',
    label: 'Thumbnail',
  },
  // {
  //   accessorKey: 'action',
  //   Header: 'action',
  //   value: 'Actions',
  //   label: 'Actions',
  // },
];
